import React, { useState } from 'react';
import { DashboardLayout } from '../components/layout/DashboardSidebar';
import api from '../services/api';

const SettingsPage = () => {
  const [passData, setPassData] = useState({ oldPassword: '', newPassword: '', confirmPassword: '' });
  const [msg, setMsg] = useState({ type: '', text: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg({ type: '', text: '' });
    if (passData.newPassword !== passData.confirmPassword) {
      setMsg({ type: 'error', text: "New passwords do not match" });
      return;
    }
    try {
      const res = await api.post('/auth/change-password', {
        oldPassword: passData.oldPassword,
        newPassword: passData.newPassword,
      });
      if (res.data.success) {
        setMsg({ type: 'success', text: 'Password updated successfully!' });
        setPassData({ oldPassword: '', newPassword: '', confirmPassword: '' });
      }
    } catch (err) {
      setMsg({ type: 'error', text: err.response?.data?.message || 'Failed to update password' });
    }
  };

  const inputClass = "w-full bg-[#0F0C29] border border-glass-border rounded-lg p-3 text-white focus:border-accent-gold outline-none";

  return (
    <DashboardLayout title="Settings">
      <div className="p-6 md:p-8 max-w-2xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">Account Settings</h1>

        <div className="bg-white/5 border border-white/10 rounded-2xl p-8 backdrop-blur-xl">
          <h3 className="text-lg text-accent-gold mb-4 font-bold">Change Password</h3>

          {msg.text && (
            <div className={`p-3 rounded-lg mb-4 text-sm ${msg.type === 'success' ? 'bg-green-500/20 text-green-300' : 'bg-red-500/20 text-red-300'}`}>
              {msg.text}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-text-muted text-sm mb-1">Current Password</label>
              <input type="password" className={inputClass} value={passData.oldPassword}
                onChange={e => setPassData({...passData, oldPassword: e.target.value})} required />
            </div>
            <div>
              <label className="block text-text-muted text-sm mb-1">New Password</label>
              <input type="password" className={inputClass} value={passData.newPassword}
                onChange={e => setPassData({...passData, newPassword: e.target.value})} required />
            </div>
            <div>
              <label className="block text-text-muted text-sm mb-1">Confirm New Password</label>
              <input type="password" className={inputClass} value={passData.confirmPassword}
                onChange={e => setPassData({...passData, confirmPassword: e.target.value})} required />
            </div>
            <button type="submit" className="w-full btn-primary py-3 rounded-xl mt-4">
              Update Password
            </button>
          </form>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default SettingsPage;
